import { QuaternaryNodeWidget } from './QuaternaryNodeWidget';
import { QuaternaryNodeModel } from './QuaternaryNodeModel';
import * as React from 'react';
import { AbstractReactFactory } from '@projectstorm/react-canvas-core';
export class QuaternaryNodeFactory extends AbstractReactFactory {
  constructor() {
    super('quaternary');
  }

  generateReactWidget(event) {
    return /*#__PURE__*/React.createElement(QuaternaryNodeWidget, {
      engine: this.engine,
      size: 50,
      model: event.model
    });
  }

  generateModel(event) {
    return new QuaternaryNodeModel();
  }

}